import {diApiEu} from '@di-shared/api/di';
import {PermissionTypeEu} from '@di-shared/api/di/type';
import {DEFAULT_CACHE_TIME} from '@di-shared/const';
import {getQueryKey} from '@shared/queryKeyMap';
import {useSuspenseQuery} from '@tanstack/react-query';

export default function useAvailableComponentEu({vin}: {vin: string}) {
  const {data: vehicleInfo} = useSuspenseQuery({
    queryKey: [getQueryKey(diApiEu.vehicle.getVehicleInfo), vin],
    queryFn: () => diApiEu.vehicle.getVehicleInfo({vin}),
    select: ({data}) => data,
    ...DEFAULT_CACHE_TIME,
  });

  function checkAvailableComponent(permissionType: keyof typeof PermissionTypeEu) {
    let isAvailableComponent;
    switch (permissionType) {
      // 안전운전점수
      case 'SAFETY_SCORE':
        isAvailableComponent = isSupportFeature(permissionType);
        break;
      // 주행기록
      case 'TRIPS':
        isAvailableComponent = isSupportFeature(permissionType);
        break;
      // ev 에너지 사용정보
      case 'EV_ENERGY_USAGE':
        isAvailableComponent = isSupportFeature(permissionType);
        break;
      // 타이어 공기압
      case 'TIRE_PRESSURE':
        isAvailableComponent = isSupportFeature(permissionType);
        break;
      // ev 배터리
      case 'EV_BATTERY':
        isAvailableComponent = isSupportFeature(permissionType);
        break;
    }
    return isAvailableComponent;
  }

  function isSupportFeature(permissionType: keyof typeof PermissionTypeEu) {
    return vehicleInfo.supportedFeatures.includes(permissionType);
  }

  const isUbiAvailable = vehicleInfo.availableSelectiveTerms.includes('UBI');
  const isUbiAgreed = vehicleInfo.consentedTerms.some((term) => term.termsCode === 'UBI' && term.consent);

  return {
    checkAvailableComponent,
    isSupportFeature,
    isCcsFullEnroll: vehicleInfo.ccsFullEnrollYn,
    isMainSupport: vehicleInfo.mainSupportYn,
    isPrimaryUserYn: vehicleInfo.primaryUserYn,
    isUbiAvailable,
    isUbiAgreed,
  };
}
